module.exports = __webpack_public_path__ + "img/tea3.96627bfe.png";